import '@angular/localize/init';
export * from './lib/feature-tax-donation-details.module';

export * from './lib/tax-donation-details/feature-tax-donation-details.component';
